/**
 * The redesign's topbar (SOC-792): breadcrumb (declared by the page via usePageShell) and the
 * Ask Data button. Markup and class names are the prototype's own so components.css styles it.
 * The account menu stays in the sidebar, which the team chose to keep as it is.
 */
import { Link } from "react-router-dom";
import { useShell } from "../../design/shell";
import { Icon } from "../../design/Sprite";

type Props = { onAskData: () => void };

/** Rendered only while a redesigned page has declared its breadcrumb; the other pages keep no topbar. */
export function Topbar({ onAskData }: Props) {
  const { crumbs } = useShell();
  if (!crumbs.length) return null;

  return (
    <header className="topbar">
      <nav aria-label="Breadcrumb">
        <ol className="breadcrumb-list" id="breadcrumb-list">
          {crumbs.map((c, i) => {
            const last = i === crumbs.length - 1;
            return (
              <li key={`${c.label}-${i}`}>
                {last || !c.to
                  ? <span className="breadcrumb-current">{c.label}</span>
                  : <Link className="breadcrumb-link" to={c.to}>{c.label}</Link>}
                {!last && <span className="breadcrumb-sep" aria-hidden="true">/</span>}
              </li>
            );
          })}
        </ol>
      </nav>

      <div className="topbar-right">
        <button className="btn btn--ai btn--md" type="button" id="ask-data-trigger" onClick={onAskData}>
          <Icon name="icon-wand-2" />Ask Data
        </button>
      </div>
    </header>
  );
}
